module.exports = __webpack_public_path__ + "static/media/society-min.455f1f7b.jpg";